"use client";
import React, { useEffect } from "react";
import CTABanner from "../../shared/CTABanner";
import ServicesSection from "./components/ServiceSection";
import TrustedResults from "./components/TrustedResult";
import { Bg } from "@/assets/img/landing";
import HeroSection from "@/shared/Hero";
import FadeInSection from "@/shared/FadeInSection";

const VideoCards = (): React.JSX.Element => (
  <div className="flex justify-center w-full mt-4 sm:-mt-28 lg:-mt-48 relative z-50 px-4">
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 w-full max-w-6xl">
      {["/TrustedBox.mp4", "/Cybersecurity.mp4", "/Services.mp4"].map(
        (src, i) => (
          <div
            key={src}
            className={`aspect-[9/11] rounded-3xl overflow-hidden ${i > 0 ? "hidden sm:block" : "block"}`}
          >
            <video
              className="w-full h-full object-cover scale-[1.015]"
              src={src}
              autoPlay
              muted
              loop
              playsInline
            />
          </div>
        ),
      )}
    </div>
  </div>
);

const Landing: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full overflow-x-hidden">
      <div className="max-w-[1600px] mx-auto">
        <HeroSection
          backgroundImage={Bg}
          tabs={[
            { label: "Redefining Digital Trust" },
            { label: "Version 2.0" },
          ]}
          heading={{
            line1: "Empowering Europe with",
            line2: "Cybersecurity & AI",
          }}
          description="From grant-backed cybersecurity assessments to production-ready AI solutions, we deliver fast, reliable, and scalable digital transformation for SMEs and enterprise clients alike."
          ctaLabel="Get Cyber-Ready for €600"
          marqueeText="Trust Vector"
          renderCards={<VideoCards />}
        />
        <FadeInSection>
          <ServicesSection />
        </FadeInSection>
        <FadeInSection>
          <TrustedResults />
        </FadeInSection>
      </div>

      <FadeInSection>
        <CTABanner />
      </FadeInSection>
    </section>
  );
};

export default Landing;
